import React from "react"
import TransferApplicationItemHeader from "./TransferApplicationItemHeader"
import TransferApplicationItemDetails from "./TransferApplicationItemDetails"
import ForFinancePaymentList from "./ForFinancePaymentList"
import { TransferApplication } from "../types"

interface TransferApplicationItemProps {
  application: TransferApplication
  onUpdate: () => void
  onCancel: () => void
}

const TransferApplicationItem: React.FC<TransferApplicationItemProps> = ({
  application,
  onUpdate,
  onCancel,
}) => {
  return (
    <div className="mb-0 border border-solid border-medium-light-gray bg-white">
      {/* ヘッダー部分 */}
      <div className="px-5">
        <TransferApplicationItemHeader application={application} />
      </div>

      {/* 区切り線 */}
      <div className="border-t border-solid border-medium-light-gray"></div>

      {/* 詳細部分 */}
      <div className="px-5">
        <TransferApplicationItemDetails
          application={application}
          onUpdate={onUpdate}
          onCancel={onCancel}
        />
      </div>

      {/* トグル部分 */}
      <ForFinancePaymentList forFinancePayments={application.payments} />
    </div>
  )
}

export default TransferApplicationItem
